import React from 'react';
import styles from './Footer.css';
import FooterLogo from '../../images/logo-bookmark.svg';
import Facebook from '../../images/icon-facebook.svg';
import Twiiter from '../../images/icon-twitter.svg';
import BackToTop from '../BackToTop/BackTop';

export const Footer = () => {
  return (
    <footer>
        <div className="footer-container">
            <div className='footer-content-container'>
                <img src={FooterLogo} alt="footer logo" />
                <ul className='footer-item'>
                <li className='nav-list'>
                    <a href='features'>features</a>
                </li>
                <li className='nav-list'>
                    <a href='#download'>Pricing</a>
                </li>
                <li className='nav-list'>
                    <a href='#contact'>Contact</a>
                </li>
                </ul>     
            </div>

            <div className="footer-icon-container">
                <img src={Facebook} alt="facebook image" />
                <img src={Twiiter} alt="twiiter image" />
            </div>
        </div>

            <BackToTop />
    </footer>
  )
}
